import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TextDirective, SliderDirective } from '../_shared/ui-helpers';

import { ColorPickerService } from '../_services/color-picker.service';
import { ColorPickerComponent } from '../_shared/color-picker.component';
import { ColorPickerDirective } from '../_directives/color-picker.directive';

// import './ng-dev-mode';

@NgModule({
  imports: [ CommonModule ],
  exports: [ ColorPickerDirective ],
  providers: [ ColorPickerService ],
  declarations: [ ColorPickerComponent, ColorPickerDirective, TextDirective, SliderDirective ],
  entryComponents: [ ColorPickerComponent ]
})
export class ColorPickerModule {}
